// extracted by mini-css-extract-plugin
export default {"root":"Input_root__qzR6h","input":"Input_input__E5rzA","label":"Input_label__NXpCD"};